import { useQuery } from "@tanstack/react-query";
import { api } from "../client";
import { queryKeys } from "../query-keys";

export function useMarketComponentHistorySelectByMarketComponentId(
  marketComponentId: string | undefined,
  page: number,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: queryKeys.marketComponentHistory.byMarketComponentId(
      marketComponentId,
      page,
    ),
    enabled: enabled && !!marketComponentId,
    queryFn: async () => {
      const res =
        await api.marketComponentHistoryApi.apiMarketComponentHistoriemarketComponentMarketComponentIdGetCollection(
          marketComponentId!,
          page,
        );

      return res.data;
    },
    staleTime: 0,
    gcTime: 0,
    meta: {
      skipGlobalError: false,
    },
  });
}
